/**
 * @file コンポーネント：フル動画ページ編集モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { ModalEditSurgeonUserlist } from "~/src/components/projects/Video/ModalEditSurgeonUserlist";
import { ModalEditTaglist } from "~/src/components/projects/Video/ModalEditTaglist";
import { InputText } from "~/src/components/uiparts/InputText";
import { Textarea } from "~/src/components/uiparts/Textarea";

// スタイル読み込み
import { StyledModal, StyledModalTime } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {props.type === "surgeonuserlist" && (
                // 執刀医リストの場合、専用コンポーネント読み込み
                <ModalEditSurgeonUserlist
                    isOpenModalEdit={props.isOpenModalEdit}
                    label={props.label}
                    list={props.content.list}
                    operationId={props.operationId}
                    setIsOpenModalEdit={props.setIsOpenModalEdit}
                    setSurgeonUserList={props.setSurgeonUserList}
                />
            )}
            {props.type === "taglist" && (
                // 症例タグリストの場合、専用コンポーネント読み込み
                <ModalEditTaglist
                    isOpenModalEdit={props.isOpenModalEdit}
                    label={props.label}
                    list={props.content.list}
                    operationId={props.operationId}
                    setIsOpenModalEdit={props.setIsOpenModalEdit}
                    setTaglist={props.setTaglist}
                />
            )}
            {props.content !== null &&
                props.type !== "surgeonuserlist" &&
                props.type !== "taglist" && (
                    // 上記以外の場合
                    <Modal
                        buttonlist={[
                            {
                                buttonType: "cancel",
                                onClick: (e) => {
                                    e.preventDefault();
                                    props.setIsOpenModalEdit(false);
                                },
                                text: localized["Label.Cancel"],
                            },
                            {
                                buttonType:
                                    props.mode === "delete"
                                        ? "caution"
                                        : "submit",
                                onClick: (e) => props.fnOnClick(e),
                                text: [
                                    props.mode === "add" &&
                                        localized["Label.Add"],
                                    props.mode === "delete" &&
                                        localized["Label.Delete"],
                                    props.mode === "edit" &&
                                        localized["Label.Save"],
                                ],
                            },
                        ]}
                        content={[
                            <StyledModal key="content">
                                {props.content.time && (
                                    // 該当の再生時間（タイムラインアイテム編集のみ）
                                    <StyledModalTime>
                                        {props.content.time}
                                    </StyledModalTime>
                                )}
                                {props.form === "input" && (
                                    // 1行フィールドタイプの場合
                                    <InputText
                                        defaultValue={props.content.context}
                                        isWide={true}
                                        onChange={(e) =>
                                            props.setContext(e.target.value)
                                        }
                                        readOnly={props.mode === "delete"}
                                    />
                                )}
                                {props.form === "textarea" && (
                                    // 複数行フィールドタイプの場合
                                    <Textarea
                                        defaultValue={props.content.context}
                                        isWide={true}
                                        onChange={(e) =>
                                            props.setContext(e.target.value)
                                        }
                                    />
                                )}
                            </StyledModal>,
                        ]}
                        hasButtonClose={true}
                        headline={props.label}
                        isShow={props.isOpenModalEdit}
                        setIsShow={props.setIsOpenModalEdit}
                    />
                )}
        </>
    );
};
